import clsx from 'clsx';
import { BiPlay } from 'react-icons/bi';

import s from './MediaPlayBadge.module.scss';

export interface MediaPlayBadgeProps {
  /** The smaller circle, for a tile with room only to say what the clip is. */
  compact?: boolean;
  /**
   * Centred over the nearest positioned ancestor — a photo card, a thumbnail —
   * rather than laid out in the flow, for a picture that is a video or a song.
   */
  overlay?: boolean;
  className?: string;
}

/**
 * The round play mark over a video's poster or a song's cover: what tells a
 * clip from a photo at a glance.
 *
 * Decorative and never a target of its own. The tile under it is what is
 * pressed, so it lets every pointer event through, and the tile carries the
 * accessible name ("Play …", "Open …"). It darkens while that tile is hovered.
 */
export const MediaPlayBadge = ({
  compact = false,
  overlay = false,
  className,
}: MediaPlayBadgeProps) => (
  <span
    className={clsx(s.badge, compact && s.compact, overlay && s.overlay, className)}
    aria-hidden="true"
  >
    <BiPlay />
  </span>
);

export default MediaPlayBadge;
